import defaultAttributes from '../defaultAttributes';

const Navigation = [
  'svg',
  defaultAttributes,
  [['polygon', { points: '3 11 22 2 13 21 11 13 3 11' }]],
];

export default Navigation;
